import { FieldProps, TimeDialogPicker, TimeDialogPickerProps, TimePicker, TimePickerProps } from '@optimus-web/core';
import { ControllerProps, useControllerHandler } from '../hooks';

export type FormTimePickerProps = TimePickerProps & FieldProps & ControllerProps<string>;

export const FormTimePickerField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: FormTimePickerProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });
    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: (newValue: string) => handleChange(null, newValue),
        value,
        readOnly: context?.readOnly || other.readOnly,
    };

    return <TimePicker {...props} />;
};

export type FormTimeDialogPickerFieldProps = TimeDialogPickerProps & FieldProps & ControllerProps<string>;

export const FormTimeDialogPickerField = ({
    defaultValue,
    name,
    onChange,
    rules,
    shouldUnregister,
    transform,
    ...other
}: FormTimeDialogPickerFieldProps) => {
    const { value, error, handleChange, onBlur, context } = useControllerHandler({
        defaultValue,
        name,
        onChange,
        rules,
        shouldUnregister,
        transform,
    });
    const props = {
        ...other,
        error,
        name,
        onBlur,
        onChange: (newValue: string) => handleChange(null, newValue),
        value,
        readOnly: context?.readOnly || other.readOnly,
    };

    return <TimeDialogPicker {...props} />;
};
